<template>
	<div
			id="main"
			class="home"
			:class="theme">
		<!--<nav-bar></nav-bar>-->
		<div class="topleftdiv"><img src="../assets/img/logo.png" alt="Bonell+Dòriga"
									 style="width: auto; height: 40px;"/></div>
		<!--<div class="toprightdiv">Bonell+Dòriga Architects<br><br>Carrer de Roger de Llúria, 116, 2-2<br>08037 - Barcelona <br>office@bonelldoriga.com</div>-->
		<div class="toprightdiv">office@bonelldoriga.com<br><a href="https://www.instagram.com/bonelldoriga" style="color: black;" target="_blank">@bonelldoriga</a></div>


		<swiper :options="swiperOption" ref="mySwiper">
			<!-- slides -->
			<swiper-slide>
				<div><img src="../assets/img/1902.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">Bonell+Dòriga receives the Lisbon Triennale Millennium bcp Début Award 2019!</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1809_2.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1809 | Argia. A Model for the Exhibition "MIRABILIA Interpretations of Italo Calvino's Invisible Cities</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1809_1.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1809 | Argia. A Model for the Exhibition "MIRABILIA Interpretations of Italo Calvino's Invisible Cities</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1804.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1804 | Galeria. A Drawing for the Exhibition "Documents (To Come)"</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><!--<img src="../assets/img/1708_lq.jpg" srcset="../assets/img/1708.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />-->
					<picture style="width: auto; height: 100vh;">
						<source media="(max-width: 1999px)" srcset="../assets/img/1708_lq.jpg" style="width: auto; height: 100vh;">
						<source media="(min-width: 2000px)" srcset="../assets/img/1708.jpg" style="width: auto; height: 100vh;">
						<img src="../assets/img/1708_lq.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;">
					</picture>
					<div class="bottomcenterdiv">1708 | Our Workspace. A Drawing for the Publication "Carnets"</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1706.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1706 | DGZ Dallwigk. Competition for a new Digital Center in Ingolstadt, First Prize (with Bonell i Gil & the ARGE Falk von Tettenborn & GINA Barcelona architects)
						, )</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1701_06.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1701 | Ground Control. Competition for the new Headquarters of a Media Company</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1701_05.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1701 | Ground Control. Competition for the new Headquarters of a Media Company</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1701_04.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1701 | Ground Control. Competition for the new Headquarters of a Media Company</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1701_03.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1701 | Ground Control. Competition for the new Headquarters of a Media Company</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1701_02.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1701 | Ground Control. Competition for the new Headquarters of a Media Company</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1701_01.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1701 | Ground Control. Competition for the new Headquarters of a Media Company</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1612_02.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1612 | LOGMA. Competition in Málaga (in association with MHAP)</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1612_01.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1612 | LOGMA. Competition in Málaga (in association with MHAP)</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1611.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1611 | A Series of Rooms. A Collection of Domestic Spaces --> <a href="https://www.aseriesofrooms.com" style="color: black;" target="_blank">HERE</a></div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1610.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1610 | Castellar. Renovation of a Housing Building</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1609.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1609 | Ordinary Floorplans. Contribution to Cartha's "Issue II - The Architecture of the City. A Palimpsest"</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1608.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1608 | Sydhavnen. Competition for a New Church in Copenhagen</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1606_03.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1606 | Bertran II. A Garden</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1606_02.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1606 | Bertran II. A Garden</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1606_01.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1606 | Bertran II. A Garden</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1605_07.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1605 | Comte Borrell. Renovation of an apartment</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1605_06.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1605 | Comte Borrell. Renovation of an apartment</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1605_05.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1605 | Comte Borrell. Renovation of an apartment</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1605_04.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1605 | Comte Borrell. Renovation of an apartment</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1605_03.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1605 | Comte Borrell. Renovation of an apartment</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1605_02.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1605 | Comte Borrell. Renovation of an apartment</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1605_01.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1605 | Comte Borrell. Renovation of an apartment</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1602_06.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1602 | Llur Table</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1602_05.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1602 | Llur Table</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1602_04.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1602 | Llur Table</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1602_03.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1602 | Llur Table</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1602_02.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1602 | Llur Table</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1602_01.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1602 | Llur Table</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1601_03.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1601 | Bertran I. Renovation of an apartment</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1601_02.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1601 | Bertran I. Renovation of an apartment</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1601_01.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1601 | Bertran I. Renovation of an apartment</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1512_04.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1512 | Madrazo. Renovation of an apartment</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1512_03.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">P1512 | Madrazo. Renovation of an apartment</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1512_02.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1512 | Madrazo. Renovation of an apartment</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1512_01.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1512 | Madrazo. Renovation of an apartment</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1506_05.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1506 | I am a Treasure. Competition for an Exhibition Space and Landscape Project in Warsaw, Special Mention</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1506_04.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1506 | I am a Treasure. Competition for an Exhibition Space and Landscape Project in Warsaw, Special Mention</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1506_03.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1506 | I am a Treasure. Competition for an Exhibition Space and Landscape Project in Warsaw, Special Mention</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1506_02.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1506 | I am a Treasure. Competition for an Exhibition Space and Landscape Project in Warsaw, Special Mention</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1506_01.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1506 | I am a Treasure. Competition for an Exhibition Space and Landscape Project in Warsaw, Special Mention</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1501.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1501 | Appenzellerhaus. Housing Competition (in association with Carla Ferrando and Pablo Garrido)</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1414_05.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1414 | Galeria Eixample</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1414_04.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1414 | Galeria Eixample</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1414_03.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1414 | Galeria Eixample</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1414_02.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1414 | Galeria Eixample</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1414_01.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1414 | Galeria Eixample</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1411.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1411 | Loire-et-Loges. Competition, Special Mention</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1410.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1410 | Sessay. Competition</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1408.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1408 | La musa inquiteante. Mannequin for a scarves shop</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1406.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1406 | Tuset Street. Renovation of an Office Space</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1403_03.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1403 | Pfefferkuchenhaus. Competition for a School in St Moritz</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1403_02.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1403 | Pfefferkuchenhaus. Competition for a School in St Moritz</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1403_01.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1403 | Pfefferkuchenhaus. Competition for a School in St Moritz</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1303.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1303 | Plaça Reial Daurada. Competition, Extraordinary Prize</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1201_03.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1201 | Rosselló. Renovation of an apartment</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1201_02.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1201 | Rosselló. Renovation of an apartment</div>
				</div>
			</swiper-slide>

			<swiper-slide>
				<div><img src="../assets/img/1201_01.jpg" alt="Bonell+Dòriga" style="width: auto; height: 100vh;" />
					<div class="bottomcenterdiv">1201 | Rosselló. Renovation of an apartment</div>
				</div>
			</swiper-slide>

			<!-- Optional controls -->
			<!--<div class="swiper-pagination"  slot="pagination"></div>-->
			<div class="swiper-button-prev" slot="button-prev"></div>
			<div class="swiper-button-next" slot="button-next"></div>
			<!--<div class="swiper-scrollbar"   slot="scrollbar"></div>-->
		</swiper>
		<!--<logo-bar></logo-bar>
		<footer-bar></footer-bar>-->
	</div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    import router from '../router'
    import { localStorageMixin } from '../mixins'
    import FooterBar from '../components/FooterBar.vue'
    import LogoBar from '../components/LogoBar.vue'
    import NavBar from '../components/NavBar.vue'
    import Field from '../components/Field.vue'
    import Message from '../components/Message.vue'
    import Preview from '../components/Preview.vue'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'

    import 'swiper/dist/css/swiper.css'

    export default {
        name: 'main',

        mixins: [localStorageMixin],

        components: {

            FooterBar,
            LogoBar,
            Field,
            Message,
            NavBar,
            Preview,
            swiper,
            swiperSlide

        },

        data: () => ({
            logoUrl: '../assets/img/bonelldoriga_wh_nm_3.png',
            logoNormalUrl: '../assets/img/bonelldoriga_wh_nm_3.png',
            logoHighlightUrl: '../assets/img/bonelldoriga_wh_hg_3.png',
            fontSize: '',
            fields: {
                email: {
                    name: 'Email Address',
                    value: '',
                    type: 'text',
                    placeholder: 'monica@raviga.com',
                    autofocus: false
                },
                password: {
                    name: 'Password',
                    value: '',
                    type: 'password',
                    placeholder: 'Super, secret',
                    autofocus: false
                }
            },
            error: null,
            swiperOption: {
                centeredSlides: true,
                pagination: '.swiper-pagination',
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                slidesPerView: 1,
                // effect: 'fade',
                paginationClickable: true,
                spaceBetween: 0,
                loop: true
            }
        }),

        computed: {
            ...mapGetters([
                'user',
                'theme'
            ])
        },

        methods: {
            ...mapActions([
                'SIGN_UP_USER',
                'INIT_NOTES'
            ]),

            onCreateAccount () {
                if (this.fields.email.value.length == 0) {
                    this.error = 'Please enter an email realestate.'
                    return
                }

                if (this.fields.password.value.length == 0) {
                    this.error = 'Please enter a password.'
                    return
                }

                const data = {
                    email: this.fields.email.value,
                    password: this.fields.password.value
                }

                this.SIGN_UP_USER(data)
                    .then(() => {
                        this.ls_pushUser(this.user)
                        console.log()
                        this.INIT_NOTES()
                            .then(() => this.$router.push({name: 'app'}))
                            .catch((error) => this.error = error.message)
                    })
                    .catch((error) => {
                        this.error = error.message
                    })
            },

            onQuoteRequest () {
                this.$router.push({name: 'quote-request', query: {email: this.fields.email.value}})
            },

            onSignUp () {
                this.$router.push({name: 'signup', query: {email: this.fields.email.value}})
            },

            onLogIn () {
                this.$router.push({name: 'login'})
            },

            closeMessage () {
                this.error = null
            }
        },

        head: {
            title: {
                inner: 'Projects'
            }
        }

    }
</script>

<style scoped>

	.swiper-container {
		height: 100vh;
		width: 100%;
		text-align: center;
	}

	.slide-img {
		width: 100%;
		height: auto;
	}

	.topleftdiv {
		top: 1em;
		left: 1em;
		position: absolute;
		font-family: "Aktiv Grotesk Corp",sans-serif;
		font-size: small;
		color: black;
		z-index: 9999;
	}

	.toprightdiv {
		top: 1em;
		right: 1em;
		position: absolute;
		text-align: right;
		font-family: "Aktiv Grotesk Corp",sans-serif;
		font-size: small;
		color: black;
		z-index: 9999;
	}

	.bottomcenterdiv {
		bottom: 4em;
		position: relative;
		font-family: "Aktiv Grotesk Corp",sans-serif;
		font-size: small;
		color: black;
		z-index: 9999;
	}

	.swiper-button-prev {
		background-image: none;
		left: 0;
		width: 50vw;
		height: 80vh;
		top: 14vh;

	}

	.swiper-button-next {
		background-image: none;
		right: 0;
		width: 50vw;
		height: 80vh;
		top: 14vh;
	}

</style>


// WEBPACK FOOTER //
// Main.vue?15f73fc9